module.exports = "import VrPlayer from 'react-vr-player';\n\n[...]\n\nrender() {\n    const sources = [\n        { url: '/videos/video.webm', type: 'video/webm'},\n        { url: '/videos/video.mp4', type: 'video/mp4'}\n    ];\n    return (\n        <div>\n            <VrPlayer sources={ sources } />\n        </div>\n    );\n}\n"


/*****************
 ** WEBPACK FOOTER
 ** ./source/vr-player/example1.txt
 ** module id = 127
 ** module chunks = 0
 **/